import type { Broker } from "../types";

export const MOCK_BROKERS: Broker[] = [
  { id: 1, name: "Alliant" },
  { id: 2, name: "Gallagher" },
  { id: 3, name: "Lockton" },
  { id: 4, name: "Marsh McLennan Agency" },
  { id: 5, name: "USI" },
];
